<script setup>
import { computed } from 'vue'

import { useStore } from 'vuex'

import BackButton from '@/components/Atoms/BackButton.vue';
import Title from '../ui/Title.vue';
import PlayoutMode from './PlayoutMode.vue';
import PlayoutPreview from './PlayoutPreview.vue';
import PlayoutSidebarTabs from './PlayoutSidebarTabs.vue';
import PlayoutControls from './PlayoutControls.vue';
import StreamService from '../../services/StreamService';

const props = defineProps({
  mediaPulse: {
    type: Object,
  },
})

const emit = defineEmits(['enable-stream'])

const store = useStore()

const playout = computed(() => store.getters['Streams/tvPlayout'])

const saveNewName = (newName) => {
  StreamService.setStreamName(playout?.value._id, newName);
}

const enableStream = () => {
  emit('enable-stream')
}
</script>

<template>
  <aside class="border-r border-surface-2 pt-8 px-3">
    <div class="flex items-center gap-2 mb-4">
      <BackButton to="/tv-playout" />
      <Title :editable="true" :title="playout?.name" @changed="saveNewName" />
		</div>
    <PlayoutMode :mediaPulse="mediaPulse" class="mb-4" />
    <PlayoutPreview class="mb-4" :mediaPulse="mediaPulse" />
    <PlayoutSidebarTabs :mediaPulse="mediaPulse" class="mb-4" />
    <PlayoutControls @enable-stream="enableStream" />
  </aside>
</template>

<style scoped>
</style>
